import React from 'react';
import HojaCaratula from './base/HojaCaratula';

// Etiquetas EXACTAS de la plantilla (templates/caratula/caratula_rti.docx) y en su mismo
// orden: el modal es una vista previa, así que lo que se lee acá tiene que coincidir
// renglón por renglón con el papel. `guardable` marca los que además de imprimirse
// vuelven al cliente/trámite (ver CaratulaRtiDocumentoService.persistirDatosGuardables).
const CAMPOS = {
    art: { label: 'ART', tipo: 'sino' },
    posible212: { label: 'POSIBLE 212', tipo: 'sino' },
    liq: {
        label: 'LIQ', tipo: 'texto',
        nota: 'Viene de la fecha de liquidar del trámite. Lo que edites acá va solo al documento: para cambiarla de verdad, editala en la ficha del trámite (al lado de la carpeta).',
    },
    cuota: { label: 'CUOTA', tipo: 'texto', guardable: true },
    ingreso: { label: 'INGRESO', tipo: 'fecha' },
    pacto: { label: 'PACTO', tipo: 'sino' },

    claveFiscal: { label: 'CLAVE FISCAL', tipo: 'clave', guardable: true },
    claveCvss: { label: 'CLAVE CVSS', tipo: 'clave', guardable: true },
    referencia: { label: 'REFERENCIA', tipo: 'texto', resaltada: true },
    cidi: { label: 'CIDI', tipo: 'clave', guardable: true },

    apellidoNombre: { label: 'APELLIDO/NOMBRE', tipo: 'texto' },
    dniCuit: { label: 'DNI/CUIT', tipo: 'texto' },
    fechaNacimiento: { label: 'FECHA DE NACIMIENTO', tipo: 'fecha', guardable: true, noFutura: true },
    domicilioDni: {
        label: 'DOMICILIO DNI', tipo: 'domicilio', estructurado: 'domicilioDniDatos', guardable: true,
        nota: 'Se guarda en el domicilio DNI del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    domicilioReal: {
        label: 'DOMICILIO REAL', tipo: 'domicilio', estructurado: 'domicilioRealDatos', guardable: true,
        nota: 'Se guarda en el domicilio REAL del cliente (el barrio que ya tenga se conserva). Vacío no borra nada.',
    },
    telefono: {
        label: 'Nº TELEFONICO', tipo: 'texto',
        nota: 'Trae el teléfono propio y los contactos adicionales del cliente. Se editan desde la ficha del cliente.',
    },
    mail: { label: 'MAIL', tipo: 'email', guardable: true },
    estadoCivil: { label: 'ESTADO CIVIL', tipo: 'estadoCivil', guardable: true },
    conyuge: { label: 'CON', tipo: 'texto', guardable: true },
    relacionDependencia: { label: 'RELACION DE DEPENDENCIA', tipo: 'texto' },
    autonomoMonotributo: { label: 'AUTONOMO O MONOTRIBUTO', tipo: 'texto' },
    aportesProvincia: { label: 'APORTES PROVINCIA', tipo: 'sino', guardable: true },
    ddjjSalud: { label: 'DDJJ DE SALUD', tipo: 'sino', guardable: true },
    regularidad: { label: 'REGULARIDAD', tipo: 'texto' },
    nivelEducativo: { label: 'NIVEL EDUCATIVO ALCANZADO', tipo: 'texto' },
    puestoCargo: { label: 'PUESTO O CARGO QUE OCUPA', tipo: 'texto' },
    patologia: { label: 'PATOLOGÍA', tipo: 'texto', guardable: true },
    turnoMedica: { label: 'TURNO CON LA MÉDICA', tipo: 'texto', guardable: true },
    turnoPericia: { label: '*TURNO PERICIA MÉDICA', tipo: 'texto', guardable: true },
    observaciones: { label: 'OBSERVACIONES', tipo: 'multilinea', guardable: true },
};

// Las 3 cajitas de arriba del documento (son cuadros de texto flotantes en el .docx).
const CAJAS_CABECERA = [
    ['art', 'posible212'],
    ['liq', 'cuota'],
    ['ingreso', 'pacto'],
];

// Bloque principal: cada entrada es una fila. Un array de 2 keys = dos columnas, igual
// que los renglones compuestos del documento.
const FILAS_CUERPO = [
    ['apellidoNombre'],
    ['dniCuit'],
    ['fechaNacimiento'],
    ['domicilioDni'],
    ['domicilioReal'],
    ['telefono'],
    ['mail'],
    ['estadoCivil', 'conyuge'],
    ['relacionDependencia'],
    ['autonomoMonotributo'],
    ['aportesProvincia', 'ddjjSalud'],
    ['regularidad'],
    ['nivelEducativo'],
    ['puestoCargo'],
    ['patologia'],
    ['turnoMedica'],
    ['turnoPericia'],
    ['observaciones'],
];

// CLAVE FISCAL/CVSS y REFERENCIA van fuera del recuadro, tal como están en el papel.
const FILAS_PREVIAS = [
    ['claveFiscal', 'claveCvss'],
    ['referencia', 'cidi'],
];

// Cómo se dibuja la hoja: título del documento, las cajitas de arriba, los renglones que
// van fuera del recuadro y el bloque principal. HojaCaratula pone el resto (modal, aviso,
// hoja A4 y botones), que es igual en las ocho carátulas.
const LAYOUT = {
    tituloDoc: 'DATOS PERSONALES',
    leyendaDoc: 'Retiro por Invalidez – LEY: 24241',
    cabecera: CAJAS_CABECERA,
    filasPrevias: FILAS_PREVIAS,
    cuerpo: FILAS_CUERPO,
};

/**
 * Modal de la Carátula RTI. Muestra los renglones prellenados (lo que ya está en el
 * cliente/trámite, o calculado desde los aportes) y en blanco lo que falta, para completar
 * antes de generar. Al confirmar, "Guardar y generar" persiste los renglones guardables y
 * emite el .docx con el DTO tal cual quedó en el formulario (WYSIWYG).
 */
export default function ModalCaratulaRti(props) {
    return (
        <HojaCaratula
            {...props}
            titulo="Generar Carátula RTI"
            nombreDocumento="la Carátula RTI"
            campos={CAMPOS}
            layout={LAYOUT}
        />
    );
}
